var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 37,
    viewBox: "0 0 23 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5157 16C15.2188 16 19.0315 12.4183 19.0315 8C19.0315 3.58175 15.2188 0 10.5157 0C5.81266 0 2 3.58175 2 8C2.00466 12.4164 5.81459 15.9956 10.5157 16ZM10.5157 4C12.8673 4 14.7736 5.79088 14.7736 8C14.7736 10.2091 12.8673 12 10.5157 12C8.16421 12 6.25788 10.2091 6.25788 8C6.25788 5.79088 8.16421 4 10.5157 4Z",
    fill: "#F5F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5776 23.0243C4.52895 23.5379 -0.0792671 28.3393 0.00103354 34.0443V34.3336C0.00103354 35.4382 0.954196 36.3336 2.12997 36.3336C3.30575 36.3336 4.25891 35.4382 4.25891 34.3336V33.9643C4.19491 30.4615 6.94656 27.4744 10.6457 27.031C14.5505 26.6672 18.0299 29.3461 18.4171 33.0144C18.44 33.2313 18.4516 33.449 18.4518 33.667V34.3336C18.4518 35.4382 19.4049 36.3336 20.5807 36.3336C21.7565 36.3336 22.7096 35.4382 22.7096 34.3336V33.6669C22.7027 27.7692 17.6078 22.9935 11.33 23C11.079 23.0003 10.828 23.0084 10.5776 23.0243Z",
    fill: "#F5F6FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.83ca5e97308d31e17ba0f4c08a590193.svg";
export { ForwardRef as ReactComponent };